import { getTemplateNavHeaderPrimaryStyles } from './NavHeaderPrimary.styles'

const t = document.createElement('template')
t.innerHTML = `
<div class="dropdown-item" role="menuitem">
  <wa-icon></wa-icon>  
  <slot></slot>
</div>
`

class NavHeaderPrimaryMenuItem extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderPrimaryStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('NavHeaderPrimaryMenuItem connectedCallback', this)
  }
}

if (!customElements.get('ts-navheader-primary-menu-item')) {
  customElements.define('ts-navheader-primary-menu-item', NavHeaderPrimaryMenuItem)
}
export { NavHeaderPrimaryMenuItem }
